<app-breadcrumbs></app-breadcrumbs>

@if (isLoading == true) {
  <div class="loading-message">
    Loading (may take a while if database needs to spin up)...
  </div>
}
<div [cfaLoading]="isLoading">

  <div class="section-header">
    <h3 class="subheading">Fortigates</h3>
    <div class="nav-cards-container" class="cards">
      <mat-card class="card">
        <mat-card-content class="card-content">
          <h3 class="card-header">{{ fortinetAvgOfflineEventsPerDay | number : '1.2-2' }}</h3>
          avg offline events/day
        </mat-card-content>
      </mat-card>
      <mat-card class="card">
        <mat-card-content class="card-content">
          <h3 class="card-header">{{ fortinetAvailCurrentMonth | number : '1.2-2' }} %</h3>
          this month
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div echarts [options]="fortinetsOption" class="demo-chart"></div>

  <div class="section-header">
    <h3 class="subheading">Mists</h3>
    <div class="nav-cards-container" class="cards">
      <mat-card class="card">
        <mat-card-content class="card-content">
          <h3 class="card-header">{{ mistAvailCurrentMonth | number : '1.2-2' }} %</h3>
          this month
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div echarts [options]="mistsOption" class="demo-chart"></div>

</div>
